// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + {"70":"f2129e1e2de8272f7baf","143":"aee39a5f82a3d871192a","557":"802a5c6707ebeb17a575","584":"11162bc70f5cbec7eee3","742":"629553374ec8b5a7ad77","758":"3ec5013544317d4fde35"}[chunkId] + ".js";
};